<template>
  <div
    class="card mb-0"
    :class="{'h-100': visible}"
  >
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div
            class="back-circle small mr-2 cursor-pointer"
            @click.prevent="visible=!visible"
          >
            <i
              v-if="visible"
              class="fa fa-chevron-up"
            />
            <i
              v-else
              class="fa fa-chevron-down"
            />
          </div>
          <h4 class="d-inline-block mb-0">
            {{ $t('vendorManagementRequestCreationChart.soruStatistikas') }}
          </h4>
        </div>
        <div class="text-right">
          {{ $t('vendorManagmentPuchaseChart.son30Gn') }} <span class="text-primary">
            {{ $t('vendorManagementRequestCreationChart.soru', {totalRequestsCreated: totalRequestsCreated}) }}
          </span>
        </div>
      </div>

      <div
        v-show="visible"
        class=" mt-3"
      >
        <div class="m-2 text-left d-flex">
          <div
            v-for="d in chartData.datasets"
            :id="`checkbox_${d.label}`"
            class="mr-3"
          >
            <i
              class="fa fa-circle mr-1"
              :style="{color: d.backgroundColor } "
            />
            <span>{{ d.label }}</span>
          </div>
        </div>

        <LineChart
          v-if="ready"
          id="vendor-request-chart"
          :chart-options="options"
          :chart-data="chartData"
          :style="{
            height: 400
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  getCompanyRequestStatistics,

} from "@/repositories/VendorManagementRepository";

import {Line as LineChart} from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  TimeScale
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    TimeScale
)


const dayjs = require('dayjs');


export default {

  components: {LineChart},
  data() {
    return {
      mediaBase: mediaBase,
      companyRequestStatistics: [],
      companyRequestActiveStatistics: [],
      ready: false,
      visible: true
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
    maxHeight() {
      return Math.max(this.chartData.datasets[0].data) || 5;
    },
    totalRequestsCreated() {
      let count = 0;
      this.companyRequestStatistics.forEach((s) => {
        count += s.counter;
      })
      return count;
    },
    options() {
      return {
        responsive: true,

        aspectRatio: 16 / 9,
        interaction: {
          intersect: false,
          mode: 'index',
        },
        scales: {
          y: {
            beginAtZero: true,
            min: 0,
            suggestedMax: 3,
            ticks: {
              stepSize: 1
            }
          },

          x: {
            ticks: {
              major: {
                enabled: true
              },
              font: function (context) {
                if (context.tick && context.tick.major) {
                  return {
                    weight: 'bold',
                  };
                }
              }
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
        }
      };
    },
    chartData() {

      let data = {
        labels: [],
        datasets: [
          {
            label: this.$t("vendorManagementChart.requestCreationChart.label1"),
            backgroundColor: '#6390F8',
            borderColor: '#6390F8',
            lineTension: 0.5,
            pointStyle: 'circle',
            pointRadius: 3,
            pointHoverRadius: 6,
            pointBackgroundColor: '#ffffff',
            fill: true,
            data: [],
          },
          {
            label: this.$t("vendorManagementChart.requestCreationChart.label2"),
            backgroundColor: '#CAE8E1',
            borderColor: '#CAE8E1',
            lineTension: 0.5,
            pointStyle: 'circle',
            pointRadius: 3,
            pointHoverRadius: 6,
            pointBackgroundColor: '#ffffff',
            fill: true,
            data: [],
          }
        ]
      };


      this.companyRequestStatistics.forEach((s) => {
        data.labels.push(dayjs(s.reportDate).format('DD MMM'));
        data.datasets[0].data.push(s.counter);
      })
      this.companyRequestActiveStatistics.forEach((s) => {
        data.datasets[1].data.push(s.counter);
      })


      return data;

    }

  },
  mounted() {


    this.getFormFormSectorStatistics();

  },
  methods: {


    getFormFormSectorStatistics() {

      getCompanyRequestStatistics(this.token).then(({code, active, create}) => {
        if (code === 200) {
          this.companyRequestStatistics = create;
          this.companyRequestActiveStatistics = active;
        }
        this.ready = true;
      })

    },

  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
